<template>
	<div>
		<el-form label-position="left" label-width="80px" :model="breatheForm" ref="breatheForm">
			<el-form-item prop="fsIp" label="外呼类型：">
				<el-select v-model="breatheForm.type" size="small" filterable>
					<el-option v-for="item in [{id: '*5', name: '外线'}, {id: '*1', name: '分机'}]" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="phone" label="被叫号码：">
				<el-input v-if="breatheForm.type === '*5'" v-model="breatheForm.phone" name="phone" placeholder="请输入" autocomplete="on" size="small" clearable></el-input>
				<el-select v-else v-model="breatheForm.phone" size="small" filterable>
					<el-option v-for="item in extensList" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="displayPhone" label="外显号码：">
				<el-select v-model="breatheForm.displayPhone" size="small" filterable>
					<el-option v-for="item in codeList" :key="item" :label="item" :value="item"></el-option>
				</el-select>
			</el-form-item>
		</el-form>
		<div style="text-align: center;margin-top: 18px;">
			<el-button @click="handleBusyOperate" :loading="loading" size="mini" type="primary">确 认</el-button>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
	props: ['sipDriver'],
	computed: {
		...mapGetters([
			'userInfo',
			'StoreAgentInfo'
		])
	},
	watch: {
		'transferForm.type': {
			handler() {
				this.breatheForm.phone = '';
			},
			immediate:true,
			deep: true
		},
	},
	data() {
		return {
			breatheForm: {
				type: '*5',
				displayPhone: '默认',
				phone: '',
			},
			extensList: [],
			codeList: [],
			loading: false
		}
	},
	mounted() {
		this.codeList = [];
		this.$api.apiPostSelectQueryCallERlist({projectCode: this.userInfo.brandIdentify}).then(response => {
			if(response.errcode != 0) return;
			this.codeList.push('默认');
			for(let item of response.data) {
				this.codeList.push(item);
			}
		});
		this.extensList = [];
		this.$api.apiPostProjectExtensList({
			projectCode: this.userInfo.brandIdentify,
		}).then(response => {
			if(response.errcode != 0) return;
			for(const item of response.data) {
				if(item.ext != this.userInfo.deviceCode) {
					this.extensList.push({
						id: item.ext,
						name: item.nickname
					});
				}
			}
		});
	},
	methods: {
		...mapMutations({
			'SET_IS_CALL': 'telService/SET_IS_CALL',
			'SET_IS_ANSWER': 'telService/SET_IS_ANSWER',
			'SET_SOFT_PHONE_IN_MSG': 'telService/SET_SOFT_PHONE_IN_MSG',
		}),
		handleBusyOperate() {
			const self = this;
			if(!self.breatheForm.phone){
				self.$message.error(`请填写被叫号码`);
				return;
			}
			self.SET_IS_CALL(true);
			self.SET_IS_ANSWER(false);
			self.$emit('signClose');
			self.loading = false;
			if(self.breatheForm.displayPhone !== '默认') {
				self.$api.apiPostProjectExtensEditDevice({
					projectCode: self.userInfo.brandIdentify,
					domain: self.StoreAgentInfo.domain,
					ext: self.StoreAgentInfo.sipCode,
					calleridText: self.breatheForm.displayPhone
				});
				self.SET_SOFT_PHONE_IN_MSG({
					msg: `外显号码`, 
					data: {
						displayPhone: self.breatheForm.displayPhone
					}
				});
			}
			self.SET_SOFT_PHONE_IN_MSG({
				msg: `外呼电话信息`, 
				data: {
					phone: self.breatheForm.phone,
					type:  self.breatheForm.type,
					brandId: self.userInfo.brandIdentify,
					channelId: 'phone',
					direction: 'OB',
					callingNumber: self.userInfo.deviceCode,
					calledNumber: self.breatheForm.phone,
					csrUserId: this.userInfo.userId,
					csrUserName: this.userInfo.nickname,
					startTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
				}
			});
			self.sipDriver._call(self.breatheForm.phone, {
				brandId: self.userInfo.brandIdentify,
				channelId: 'phone',
				direction: 'OB',
				callingNumber: self.userInfo.deviceCode,
				calledNumber: self.breatheForm.phone,
				csrUserId: this.userInfo.userId,
				csrUserName: this.userInfo.nickname,
				startTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
			}, self.breatheForm.type, 'Breathe');
		},
	}
}
</script>